
import ROUTERS from '../../commons/constans/router';
import React, { lazy } from 'react';

const InformationComponent = lazy(() => import('./containers/informationContainer'));

const route = [
  {
    path: ROUTERS.INFORMATION,
    title: 'Information',
    exact: true,
    public: false,
    component: <InformationComponent />
  },
];

export default route;